import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import moment, { Moment } from 'moment'

import { observer } from 'mobx-react'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import ContractTooltip from 'modules/contracts/components/ContractDetails/ContractTooltip'
import type Employee from 'modules/employees/store/models/Employee'

import Details from './Details'

interface Props {
  endDate?: Moment | null
  canEdit: boolean
  employee: Employee
}

const EndDate = ({ endDate, canEdit, employee }: Props) => {
  const now = moment()
  const isFuture = endDate ? endDate.isAfter(now) : false
  const formattedEndDate = endDate ? dateToString(endDate, 'ui_dmy_long') : null
  const tooltipInformation = isFuture
    ? i18n.t('contract_versions.contract_information.end_date_tooltip_future', {
        endDate: formattedEndDate,
      })
    : i18n.t('contract_versions.contract_information.end_date_tooltip_past', {
        endDate: formattedEndDate,
      })

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 3 }} gap="s2">
      <Box gap="s8">
        <Box flexDirection="row" alignItems="center" gap="s4" height="s24">
          <Text size="200" weight="normal" color="grey800">
            {i18n.t('contract_versions.contract_information.end_date')}
          </Text>
          {endDate && <ContractTooltip information={tooltipInformation} icon="info-circle-line" />}
        </Box>
        {endDate && (
          <Text size="300" weight="medium" color="grey1000">
            {formattedEndDate}
          </Text>
        )}
        {!endDate && (
          <Text size="300" weight="medium" color="grey600">
            {i18n.t('contract_versions.contract_information.not_informed')}
          </Text>
        )}
      </Box>
      {endDate && <Details endDate={endDate} canEdit={canEdit} employee={employee} />}
    </Box>
  )
}

export default observer(EndDate)
